import React from 'react'
import Pt from 'prop-types'
import Mpt from 'react-moment-proptypes'
import moment from 'moment'

import { convertToDuration } from './util'

export default function Ago({
  Component = 'span',
  duration,
}) {
  const title = !moment.isDuration(duration) && duration.format()

  return (
    <Component title={title}>
      {convertToDuration(duration).humanize(true)}
    </Component>
  )
}

Ago.propTypes = {
  Component: Pt.node,
  duration: Pt.oneOfType([
    Mpt.momentDurationObj,
    Mpt.momentObj,
  ]).isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Time/Ago.jsx